export default __webpack_public_path__ + "static/media/HazelLovelace.7f79cca2.png";